module.exports = __webpack_public_path__ + "img/blog.d7561d3c.svg";